import React from "react";

/* eslint-disable react/display-name */
export default React.memo(function CheckIcon() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.4343 7.43431C14.7467 7.74673 14.7467 8.25327 14.4343 8.56569L9.90883 13.0912C9.59641 13.4036 9.08988 13.4036 8.77746 13.0912L6.25198 10.5657C5.93956 10.2533 5.93956 9.74673 6.25198 9.43431C6.5644 9.1219 7.07093 9.12189 7.38335 9.43431L9.34315 11.3941L13.3029 7.43431C13.6154 7.1219 14.1219 7.1219 14.4343 7.43431Z"
                fill="#1D1D1B"
            />
        </svg>
    );
});